import React, { createContext, useContext, useState, useEffect } from 'react';
import { ThemeProvider } from "@emotion/react";
import { createTheme } from "@mui/material/styles";
import { Container, CssBaseline } from "@mui/material";
import NavigationBar from "./components/NavigationBar";
import PageRenderer from './Renderer/PageRenderer';
import theme from './theme'; // Adjust the path as needed
import { AuthProvider, LoadingProvider, SnackbarProvider, NavigationProvider, SoftwareVersionProvider } from "./Context/Contexts";
import "./Services/Lang/i18n";
type Page = 'home' | 'settings'; // Add more page types as needed


export default function App(): JSX.Element {

    const [currentPage, setCurrentPage] = useState<Page>('home');



    return (
        <LoadingProvider>
            <SoftwareVersionProvider>
            <AuthProvider>
                <SnackbarProvider>
                    <ThemeProvider theme={theme}>
                        <CssBaseline />

                        <Container component="main" disableGutters maxWidth={false}>
                            <NavigationProvider>
                                <NavigationBar />
                                <PageRenderer />
                            </NavigationProvider>

                        </Container>
                    </ThemeProvider>
                </SnackbarProvider>
                </AuthProvider>
            </SoftwareVersionProvider>
        </LoadingProvider>
    );
}
